import {Box, Grid, Typography} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import {useAddKanbanItem, useCreateItemDataAPI} from 'hooks';
import {Add, Minus} from 'iconsax-react';
import {ItemStatus} from 'models/board';
import {ItemDataResponse} from 'models/board/itemData';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {appRoutes} from 'routes';
import AddKanbanItemInput from './AddKanbanItemInput';

interface AddKanbanItemProps {
    itemsTotalCount: number;
    column: ItemStatus;
    addBoardItemsData: (value: ItemDataResponse) => void;
}

export const AddKanbanItem: React.FC<AddKanbanItemProps> = ({column, itemsTotalCount = 0, addBoardItemsData}) => {
    const {tenantId, workspaceId, boardId} = useParams();
    const {
        setAddTaskBox,
        addTaskBoxOpenState,
        getNewlyCreatedItemWithTitleSetToTheFirstField,
        closeAddTaskContainer,
        fields,
    } = useAddKanbanItem(column.id);

    const {createItemData, createItemDataLaoding, createItemDataResponse} = useCreateItemDataAPI();
    const [itemsCreatedCount, setItemsCreatedCount] = useState(0);
    const handleTaskSubmit = (value: string) => {
        const request = getNewlyCreatedItemWithTitleSetToTheFirstField(value);
        if (request) {
            createItemData({
                variables: {
                    input: request,
                },
            });
        }
    };

    const navigate = useNavigate();

    useEffect(() => {
        if (createItemDataResponse && !createItemDataLaoding) {
            addBoardItemsData({
                ...createItemDataResponse.createItemData,
                data: createItemDataResponse.createItemData.data,
            });
            closeAddTaskContainer();
            setItemsCreatedCount(prev => prev + 1);
            navigate(
                appRoutes.workspace.boadListingWithTicket(
                    tenantId,
                    workspaceId,
                    boardId,
                    createItemDataResponse.createItemData.ticketNo.toString(),
                ),
            );
        }
    }, [createItemDataResponse, createItemDataLaoding]);

    const selectedFieldUsedToCreateItem = useMemo(() => {
        return fields.find(x => x.shouldUseAsTheFieldToCreateItem);
    }, [fields]);

    const renderAddNewItemInput = useCallback(() => {
        if (addTaskBoxOpenState) {
            if (selectedFieldUsedToCreateItem) {
                return (
                    <AddKanbanItemInput
                        inputTitle={selectedFieldUsedToCreateItem.title}
                        onAddITemSubmit={handleTaskSubmit}
                        isLoading={createItemDataLaoding}
                    />
                );
            } else {
                return <Typography variant="caption">No field selected to create item</Typography>;
            }
        }
        return null;
    }, [addTaskBoxOpenState, selectedFieldUsedToCreateItem, createItemDataLaoding]);

    return (
        <Grid container alignItems="center" sx={{paddingLeft: 1, paddingRight: 1}}>
            <Grid item xs={12} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box style={{display: 'flex', alignItems: 'center'}}>
                    <Typography variant="h6">{column.title}</Typography>
                    <Typography ml={'2px'} variant="caption">{`(${itemsTotalCount + itemsCreatedCount})`}</Typography>
                </Box>
                <Box>
                    <AppIconButton
                        onClick={() => {
                            setAddTaskBox(prev => !prev);
                        }}
                    >
                        {!addTaskBoxOpenState ? <Add /> : <Minus color="red" />}
                    </AppIconButton>
                </Box>
            </Grid>
            {renderAddNewItemInput()}
        </Grid>
    );
};

export default AddKanbanItem;
